// SMS = the unified inbox filtered to SMS threads. One thread list, one
// composer — the same surface as Inbox, not a second composing experience.
//
// The old grab-bag this page carried moved to its real homes (founder-approved
// cut, 2026-08-05):
//   - Mass text via pasted phone numbers / "Lead IDs" → Segment Outreach
//     (audience picker, structural dedup, suppression gate).
//   - Live call activity → Calls (the review surface).
//   - Template strip → the outreach composer's template picker + Settings.
//   - Sequences panel → the Sequences tab.
import React from "react";
import UnifiedInbox from "../Inbox/UnifiedInbox";

export default function SMSPage() {
  return <UnifiedInbox initialFilter="sms" />;
}
